// extracted by mini-css-extract-plugin
export default {"countdownContainer":"CountdownTimer_countdownContainer__OSFA7","countdown":"CountdownTimer_countdown__hCX35"};